<template>
  <div :class="$style['filter']">
    <div :class="$style['filter__title']">
      {{ title }}

      <Btn v-if="filterStore.active.available.length" icon-right="System/close-line" color="link" size="small" @click="filterStore.resetFilter('available')">
        Reset filter
      </Btn>
    </div>

    <FormCheckbox
      :label="subtitle"
      :checked="active"
      :target-value="true"
      @input="$emit('toggle', !active)" />
  </div>
</template>
<script setup>
const filterStore = useFilterStore()
defineProps({
  title: {
    type: String,
    default: null
  },
  subtitle: {
    type: String,
    default: null
  },
  active: {
    type: [Boolean, Function],
    default: null
  }
})
</script>
<style lang="scss" module>
@use './style' as *;
</style>
